module.exports = __webpack_public_path__ + "img/btn2.9906532d.png";